<template>
	<div class="convention-hall page">
    <van-nav-bar :title="$t('concubine.concubine')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
		<div class="convention-item">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab :title="$t('concubine.city')">
					<div class="card">{{$t("concubine.city_tip")}}</div>
          <div class="beautyFirstContain ">
            <div v-for="(val, key) in addlist" :key="key">
              <div class="describe-div">{{val.name}} </div>
              <img :src="val.img"/>
            </div>
          </div>
<!--					<div class="address">
						<van-cell-group v-for="(val, key) in addlist" :key="key">
						<van-cell @click="addgo(val)">{{val.name}}</van-cell>
						</van-cell-group>

					</div>-->
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			addlist: []
		};
	},
	methods: {
    back() {
      this.$router.push({ path: 'Home' });
    },
		addgo(data) {
      this.$router.push({ path: '/ChooseDetail?id=' + data.id + '&name=' + data.name });
     /* if(data.is_has_child > 0){
        this.getAddress(data.id) ;
         // this.$router.push({ path: '/Choose?pid=' + data.id  });
      }
      else{

      }*/
		},
		getAddress(pid) {

      let  param = {pid : pid} ;

			this.$http({
				method: 'get',
				url: 'address_list',
        data: param
			}).then(res => {
				this.addlist = res.data;
				console.log('this.addlist' ,res.data)
			});
		}
	},
	created() {
    let pid = 0 ;
    if(typeof this.$route.query.pid != undefined){
      pid = this.$route.query.pid ;
    }
		this.getAddress(pid);
	}
};
</script>

<style lang="less" scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	//background-color: #f2f2f5;
  background: url(/img/login/login-bg.png);
  background-size: cover;
  background-position: 50%;
}
.nav-bar {
	background: linear-gradient(90deg, #f487e0,#988fba);
	height: 100px;
}
.van-nav-bar {
	line-height: 50px;
}
::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}
::v-deep .van-nav-bar__content {
	height: 100px;
}
.van-sidebar {
	width: 180px;
}
// /deep/ .van-col{
	// padding: 30px 0px;
// }
.convention-hall {
	display: flex;
	flex-direction: column;
	bottom: 20px;
	//background: #f2f2f5;
	height: max-content;
}
::v-deep .van-tab {
	font-size: 30px;
	line-height: 100px;
	font-weight: bold;
}
::v-deep .van-tabs__line {
	background-color: #f487e0;
}
::v-deep .van-tabs--line .van-tabs__wrap {
	height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
	padding: 0 23px;
}
.card {
	background-color: #8a637d;
	padding: 0.625rem;
	width: 95%;
	color: white;
	font-size: 0.8125rem;
	margin: 0.625rem auto;
	border-radius: 0.375rem;
}
::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

/deep/ .van-cell{
	padding: 30px 22px;
	font-size: 30px;
	line-height:30px;
}
.address {
	width: 94%;
	margin: 0 auto;
	margin-bottom: 110px;
}
 .beautyFirstContain{
   width: calc(100% - 8vw);
   margin: auto;
   display: flex ;
   align-items: flex-start;
   justify-content: space-between;
   flex-wrap: wrap;
 }

.beautyFirstContain>div {
  width: 28vw;
  height: 28vw;
  position: relative;
  margin-bottom: 2.667vw
}
.beautyFirstContain>div img{
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 1.333vw
}

.beautyFirstContain>div .describe-div  {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vw;
  color: #fff;
  font-weight: 700
}
</style>
